import axios from "axios";
import {
  webstore,
  getUid,
  getMsisdn,
  getDomain,
  getAuthEndpoint,
  getLoginCode,
} from "../helpers/auth-helpers";
import { noAuthRequired } from "./redirect.utils";
import { sendOnAuthSuccess, sendOnAuthFail } from "./dataCollection.utils";
import { setMixpanelUser } from "../../mixpanel";
import { chainUtmMedium } from "../../utils/utmTracker";

export const checkAuth = async () => {
  const uid = getUid();
  const msisdn = getMsisdn();
  const loginCode = getLoginCode();
  const domain = getDomain();
  const url = getAuthEndpoint();
  const token = webstore.getProperty("token");

  // If authentication not needed
  if (noAuthRequired()) return true;

  // If token already exist and is in LocalStorage
  if (token && token.length > 0 && !uid) return true;

  if (loginCode) url.searchParams.append("loginCode", loginCode);
  else if (msisdn) url.searchParams.append("msisdn", msisdn);
  else if (uid) url.searchParams.append("uid", uid);
  else {
    sendOnAuthFail({ uid, msisdn, err: "no_param_supplied" });
    return false;
  }

  url.searchParams.append("domain", domain);

  try {
    const response = await axios.get(url.href);
    const data = response.data;
    if (data.success) {
      const {
        rockmanId,
        token,
        msisdn: mobileNumber,
        startDate,
        renewalDate,
        status,
        serviceName,
        country,
      } = data.payload;

      webstore.add(
        { token, msisdn: mobileNumber, startDate, renewalDate, status, serviceName },
        rockmanId
      );
      sendOnAuthSuccess({ uid, msisdn });
      setMixpanelUser({ id: rockmanId });
      chainUtmMedium('portal');
      ;(window.dataLayer = window.dataLayer || []).push({
        event: 'user_login',
        user_id: rockmanId,
        rockman_id: rockmanId,
        service_name: serviceName,
        country: country,
      });
      return true;
    } else {
      const { error_reason: err } = response.data;
      sendOnAuthFail({ uid, msisdn, err });
      return false;
    }
  } catch (e) {
    const { error_reason: err } = e.response.data;
    const status = e.response.status
    sendOnAuthFail({ uid, msisdn, err });
    const errorsReason = ["sub_inactive", "sub_not_found", "sub_not_created"];
    if (status === 404 && errorsReason.includes(err)) {
      return false;
    }
    throw new Error("error in auth");
  }
};
export const fetchUserSubscriptionInfo = async () => {
  try {
    const uid = getUid();
    const domain = getDomain();
    const url = getAuthEndpoint()

    if (uid) url.searchParams.set("uid", uid);
    if (domain) url.searchParams.set("domain", domain);

    const response = await fetch(url.href);
    const data = await response.json();
    const { success, payload, error_reason } = data;

    if (success) {
      const { rockmanId, msisdn: mobileNumber, renewalDate,token } = payload;
      webstore.add({ msisdn: mobileNumber, renewalDate,token }, rockmanId);
    } else {
      console.log("Error:", error_reason || "Unknown error");
    }
  } catch (error) {
    console.error("Error fetching user subscription info:", error.message);
    throw new Error(error.message);
  }
};
